// Map #7 Floating Isles, audio half. Grass isles over a sea of clouds (the live cycle by default).
// Ambience: high whistling wind over a soft airy body (the gale lanes push both), a faint chord of singing air that swells and
// fades, distant wingbeats and sky birds by day, wind chimes on the old ruins, the far song of a sky giant (more often at
// night), owls and sparse crickets after dark. A wide open-air echo.
// Music: G lydian, 96 bpm, soaring open-sky hope: a warm pad, harp-like arps, a singing sine lead and light brushed drums.
import { MODES, type MapAudioDef } from '../../audio/mapAudioDef';

export const AUDIO: MapAudioDef = {
  id: 'floating-isles',
  ambience: {
    level: 1.07,
    beds: [
      { src: 'pink', filter: 'bandpass', freq: 1400, q: 0.8, gain: 0.35, storm: 1.5, gust: { depth: 0.7, every: [2, 6], sweep: 1.8 } },
      { src: 'pink', filter: 'lowpass', freq: 400, gain: 0.4, gust: { depth: 0.5, every: [3, 8] } },
      { src: { wave: 'sine', freqs: [392, 587.3, 784.6] }, filter: 'lowpass', freq: 1200, gain: 0.012, night: 1.4, gust: { depth: 0.9, every: [3, 8] } },
    ],
    events: [
      { kind: 'flap', every: [8, 18], gain: 0.16, day: 1, night: 0.3 },
      { kind: 'bird', every: [6, 14], gain: 0.1, day: 1, night: 0, pitch: 1.2 },
      { kind: 'whale', every: [30, 60], gain: 0.08, night: 1.3, echo: 0.8 },
      { kind: 'gust', every: [6, 12], gain: 0.3, storm: 1.5, voices: 2 },
      { kind: 'chime', every: [10, 22], gain: 0.05, echo: 0.5 },
      { kind: 'owl', every: [20, 40], gain: 0.08, day: 0, night: 1, echo: 0.5 },
      { kind: 'cricket', every: [3, 6], gain: 0.03, day: 0, night: 1, voices: 2 },
    ],
    echo: { l: 0.47, r: 0.71, fb: 0.5, damp: 3000, wet: 0.75 },
  },
  music: {
    mood: 'soaring open-sky hope (G lydian, 96 bpm)',
    score: {
      bpm: 96, steps: 16, root: 43, mode: MODES.lydian, progression: [0, 4, 5, 3, 0, 4, 3, 1],
      pad: { wave: 'sawtooth', voices: 4, detune: 10, cutoff: 2000, gain: 0.06, octave: 1, send: 0.4 },
      bass: { wave: 'triangle', cutoff: 800, atk: 0.01, dec: 0.3, sus: 0.7, rel: 0.2, gain: 0.42, octave: 0,
        pattern: '1.....5.8.....5.', hot: '1..1..5.8..8..5.' },
      arp: { wave: 'triangle', cutoff: 5000, atk: 0.002, dec: 0.35, sus: 0, rel: 0.2, gain: 0.11, octave: 2, send: 0.45,
        pattern: [0, -1, 1, -1, 2, -1, 3, -1, 4, -1, 3, -1, 2, -1, 1, -1], hot: [0, 1, 2, 3, 4, 5, 4, 3, 0, 1, 2, 3, 4, 5, 6, 5] },
      lead: { wave: 'sine', cutoff: 4000, atk: 0.05, dec: 0.4, sus: 0.8, rel: 0.35, gain: 0.13, octave: 2, send: 0.5,
        vibrato: { rate: 5, cents: 20 }, bars: [4, 6],
        motifs: [
          { notes: [[4, 4], [5, 2], [7, 6], [6, 4], [4, 4], [2, 4], [null, 8]] },
          { notes: [[0, 4], [2, 4], [4, 4], [3, 2], [2, 2], [1, 8], [null, 8]] },
        ] },
      drums: { kit: 'soft', gain: 0.7,
        main: { kick: 'X.......X.......', snare: '........x.......', hat: '..x...x...x...x.' },
        fill: { snare: '........x...x.xx' },
        hot: { kick: 'X.....x.X.....x.', snare: '....x.......x...', hat: 'x.xgx.xgx.xgx.xg', tom: '...........x..x.' } },
      echo: { steps: 3, fb: 0.4, wet: 0.28, damp: 3500 },
      level: 0.69,
    },
  },
};
